/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import Grid from "@mui/material/Grid";
import classes from "./catalog.module.css";
import constants from "../../../helper/constants";
import { connect } from "react-redux";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import draftStatus from "../../../asset/images/draftStatus.png";
import reviewStatus from "../../../asset/images/reviewStatus.png";
import placeholderImage from "../../../asset/images/image_placeholder.png";
import { withTranslation } from "react-i18next";

import Badge from "@mui/material/Badge";
import { green, red } from "@mui/material/colors";
import LockIcon from "@mui/icons-material/Lock";
import DraftsIcon from "@mui/icons-material/Drafts";
import PublicIcon from "@mui/icons-material/Public";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import currencyFormatter from "../../../helper/currencyFormatter";
import { DefaultImage } from "../../../helper/setFallbackImages";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { ViewIconNew } from "../../../component/icons/icons";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

const ProductCard = (props) => {
  const t = props.t;
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Grid
      item
      className={classes.card}
      size={{
        xs: 12,
        sm: 3,
      }}
    >
      {/* {promoSuccess === "true" &&
                <div className="custom-snackbar-color">
                    <Snackbar message="Special Promo Price Created Successfully!" open="true" autoHideDuration={4000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}></Snackbar>
                </div>} */}
      <Badge
        color="default"
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        badgeContent={
          props.solutionAction === "/myOfferings" ? (
            props.product.isSubmittedForReview ? (
              props.userPerms.includes("CUMULATOR_PRODUCT_COMMIT") ? (
                <>
                  <Tooltip title={t("PENDING_REVIEW")}>
                    {/* <FindInPageIcon style={{ color: '#f58320' }}/> */}
                    <img
                      border="0"
                      width="50"
                      // height="50"
                      style={{ marginLeft: "33px" }}
                      src={reviewStatus}
                      alt=""
                      onError={DefaultImage}
                    />
                  </Tooltip>
                </>
              ) : (
                <>
                  <Tooltip title={t("PENDING_REVIEW")}>
                    <img
                      border="0"
                      width="50"
                      // height="50"
                      style={{ marginLeft: "33px" }}
                      src={reviewStatus}
                      alt=""
                      onError={DefaultImage}
                    />
                  </Tooltip>
                </>
              )
            ) : 0 ||
              (!props.product.isSubmittedForReview &&
                !props.product.isApproved) ? (
              <>
                <Tooltip title={t("APPROVE_ALERT")}>
                  {/* <DraftsIcon style={{ color: red[500]}}/> */}
                  <img
                    border="0"
                    width="50"
                    // height="50"
                    style={{ marginLeft: "33px" }}
                    src={draftStatus}
                    alt=""
                    onError={DefaultImage}
                  />
                </Tooltip>
              </>
            ) : (
              0
            )
          ) : (
            0
          )
        }
      >
        {props.solutionAction !== "/newOrder" &&
          props.solutionAction !== "/product" ? (
          <Paper elevation={1} className={classes.paper}>
            {props.solutionAction === "/myOfferings" &&
              props.menuPaths.includes("/newOrder/:id") &&
              props.userPerms.includes("ORDERMGR_SALES_CREATE") && (
                <Tooltip title={t("PLACE_ORDER")}>
                  <svg
                    className={classes.addToCartIcon}
                    viewBox="0 0 29 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      navigate(`/newOrder/${props.product.productId}`, {
                        state: {
                          offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                          availableCustomers: props.availableCustomers || [],
                        },
                      });
                    }}

                  >
                    <path
                      d="M14.1872 16.1379H17.0247V11.5543H21.2808V8.4986H17.0247V3.91504H14.1872V8.4986H9.93105V11.5543H14.1872V16.1379ZM8.51233 29.8885C6.95173 29.8885 5.68907 31.2636 5.68907 32.9443C5.68907 34.6249 6.95173 36 8.51233 36C10.0729 36 11.3498 34.6249 11.3498 32.9443C11.3498 31.2636 10.0729 29.8885 8.51233 29.8885ZM22.6995 29.8885C21.1389 29.8885 19.8763 31.2636 19.8763 32.9443C19.8763 34.6249 21.1389 36 22.6995 36C24.2601 36 25.537 34.6249 25.537 32.9443C25.537 31.2636 24.2601 29.8885 22.6995 29.8885ZM8.75351 24.923L8.79607 24.7397L10.0729 22.2493H20.6424C21.7064 22.2493 22.6428 21.6229 23.1252 20.6756L28.6014 9.96534L26.1328 8.4986H26.1187L24.5581 11.5543L20.6424 19.1936H10.683L10.4985 18.7811L7.3206 11.5543L5.97282 8.4986L4.63922 5.44289H0V8.4986H2.83744L7.94484 20.095L6.02956 23.8382C5.80257 24.266 5.67488 24.7702 5.67488 25.305C5.67488 26.9856 6.95173 28.3607 8.51233 28.3607H25.537V25.305H9.10819C8.92375 25.305 8.75351 25.1369 8.75351 24.923Z"
                      fill={props.tenantData.color}
                    />
                    <rect
                      x="9.93115"
                      y="3.91504"
                      width="11.3498"
                      height="12.2228"
                      fill="white"
                    />
                    <path
                      d="M24.2072 8.06904H20.4831V11.7932H19.2417V8.06904H15.5176V6.82766H19.2417V3.10352H20.4831V6.82766H24.2072V8.06904Z"
                      fill={props.tenantData.color}
                    />
                  </svg>
                </Tooltip>
              )}
            <div>
              <Link
                to={
                  props.providerType === "SALES_CHNL_PROVIDER"
                    ? props.solutionAction === "/myOfferings"
                      ? `/viewProduct/${props.product.productId}?type=myOfferings`
                      : props.solutionAction === "/product" ||
                        props.solutionAction === "/newOrder"
                        ? `/viewProduct/${props.product.productOfferingId}?type=myOfferings`
                        : `/viewProduct/${props.product.productId}?type=availableOfferings`
                    : props.solutionAction === "/product" ||
                      props.solutionAction === "/newOrder"
                      ? `/product/${props.product.productOfferingId}`
                      : `/product/${props.product.productId}`
                }
              >
                <img
                  // onClick={()=>{navigate(`${location.pathname}/${props.product.productOfferingId}`)}}
                  border="0"
                  src={
                    props.product.largeImageUrl
                      ? constants.imageUrl + props.product.largeImageUrl
                      : placeholderImage
                  }
                  className={classes.cardImage}
                  alt=""
                  onError={DefaultImage}
                />
              </Link>
            </div>
            <div className={classes.cardBody}>
              <div className={classes.productTitle}>
                {props.solutionAction === "/product" ||
                  props.solutionAction === "/newOrder"
                  ? props.product.name
                  : props.product.productName}
              </div>
            </div>
            <div className={classes.cardDetail}>
              <div className={classes.priceGroup}>
                <div>
                  {props.product.isBundle && (
                    <span className={classes.catalogSmallText}>
                      {t("STARTING_FROM_TEXT")}
                    </span>
                  )}
                  <div
                    className={classes.price}
                    style={{ color: props.tenantData.color }}
                  >
                    {props.solutionAction === "/product" ||
                      props.solutionAction === "/newOrder" ? (
                      <>
                        {currencyFormatter(props.product.price.priceAmount)}
                        {props.product.price.priceType === "RC"
                          ? t("PER_MONTH")
                          : ""}
                      </>
                    ) : (
                      <>
                        {currencyFormatter(props.product.startingPrice)}
                        {/* {(Math.round(props.product.startingPrice * 100) / 100).toFixed(2)} */}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className={classes.actionGroup} align="right">
                {props.providerType === "SALES_CHNL_PROVIDER" ||
                  props.providerType === "SOLUTION_PROVIDER" ? (
                  props.solutionAction === "/myOfferings" ? (
                    props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                    props.loggedInUserType !== "ECOMMERCE_ADMIN" && (
                      <>
                        {(props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                          props.userPerms.includes("CATALOG_CREATE") ||
                          props.userPerms.includes("CATALOG_ADMIN")) && (
                            <React.Fragment>
                              {props.product.isBundle ? (
                                <Tooltip title={t("EDIT")}>
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 21 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={() => {
                                      navigate(
                                        `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=false`,
                                      );
                                    }}
                                  >
                                    <circle
                                      cx="10.5"
                                      cy="10.5"
                                      r="10.5"
                                      fill={props.tenantData.color}
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM5 16V13.7087L11.758 6.9507L14.0493 9.24205L7.29135 16H5ZM15.8213 6.60853C16.0596 6.84683 16.0596 7.23177 15.8213 7.47007L14.7031 8.58825L12.4117 6.2969L13.5299 5.17873C13.7682 4.94042 14.1532 4.94042 14.3915 5.17873L15.8213 6.60853Z"
                                      fill="white"
                                    />
                                  </svg>
                                </Tooltip>
                              ) : (
                                <Tooltip title={t("EDIT")}>
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 21 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={() => {
                                      props.editStandaloneProduct(
                                        props.product.componentId,
                                        props.product.componentType,
                                      );
                                    }}
                                  >
                                    <circle
                                      cx="10.5"
                                      cy="10.5"
                                      r="10.5"
                                      fill={props.tenantData.color}
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM5 16V13.7087L11.758 6.9507L14.0493 9.24205L7.29135 16H5ZM15.8213 6.60853C16.0596 6.84683 16.0596 7.23177 15.8213 7.47007L14.7031 8.58825L12.4117 6.2969L13.5299 5.17873C13.7682 4.94042 14.1532 4.94042 14.3915 5.17873L15.8213 6.60853Z"
                                      fill="white"
                                    />
                                  </svg>
                                </Tooltip>
                              )}
                              {props.product.isBundle && (
                                <>
                                  <Tooltip title={t("EDIT_SPECIAL_PRICING")}>
                                    <svg
                                      width="30"
                                      height="30"
                                      viewBox="0 0 21 21"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      onClick={() => {
                                        navigate(
                                          `/createSpecialPrice?packageId=${props.product.productId}&packageMode=promo`,
                                        );
                                      }}
                                    >
                                      <circle
                                        cx="10.5"
                                        cy="10.5"
                                        r="10.5"
                                        fill={props.tenantData.color}
                                      />
                                      <path
                                        d="M10.5 0C4.70156 0 0 4.70156 0 10.5C0 16.2984 4.70156 21 10.5 21C16.2984 21 21 16.2984 21 10.5C21 4.70156 16.2984 0 10.5 0ZM11.0227 15.5906L11.0273 16.3336C11.0273 16.4367 10.943 16.5234 10.8398 16.5234H10.1742C10.0711 16.5234 9.98672 16.4391 9.98672 16.3359V15.6C7.90547 15.4453 6.92578 14.2594 6.82031 12.9703C6.81094 12.8602 6.89766 12.7664 7.00781 12.7664H8.09063C8.18203 12.7664 8.26172 12.832 8.27578 12.9211C8.39531 13.6641 8.97422 14.2195 10.0125 14.3578V11.0133L9.43359 10.8656C8.20781 10.5727 7.04062 9.80859 7.04062 8.22422C7.04062 6.51562 8.33906 5.59687 9.99844 5.43516V4.66172C9.99844 4.55859 10.0828 4.47422 10.1859 4.47422H10.8445C10.9477 4.47422 11.032 4.55859 11.032 4.66172V5.42813C12.6375 5.58984 13.8422 6.52734 13.9828 7.9875C13.9945 8.09766 13.9078 8.19375 13.7953 8.19375H12.743C12.6492 8.19375 12.5695 8.12344 12.5578 8.03203C12.4641 7.34766 11.9156 6.78984 11.0227 6.66797V9.81562L11.618 9.95391C13.1367 10.3289 14.1703 11.0555 14.1703 12.682C14.1703 14.4469 12.8578 15.4313 11.0227 15.5906ZM8.49844 8.11641C8.49844 8.71172 8.86641 9.17344 9.65859 9.45938C9.76875 9.50391 9.87891 9.53906 10.0102 9.57656V6.67031C9.14531 6.78047 8.49844 7.26562 8.49844 8.11641ZM11.2289 11.2852C11.1633 11.2711 11.0977 11.2547 11.0227 11.2336V14.3672C12.0211 14.2781 12.7102 13.7297 12.7102 12.8109C12.7102 12.0914 12.3375 11.6227 11.2289 11.2852Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </Tooltip>
                                  <Tooltip title={t("REMOVE")}>
                                    <svg
                                      width="30"
                                      height="30"
                                      viewBox="0 0 21 21"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      onClick={() => {
                                        props.removeProduct(
                                          props.product.productId,
                                          props.productIndex,
                                        );
                                      }}
                                    >
                                      <circle
                                        cx="10.5"
                                        cy="10.5"
                                        r="10.5"
                                        fill={props.tenantData.color}
                                      />
                                      <path
                                        d="M10.5 0C4.704 0 0 4.704 0 10.5C0 16.296 4.704 21 10.5 21C16.296 21 21 16.296 21 10.5C21 4.704 16.296 0 10.5 0ZM15.75 11.55H5.25V9.45H15.75V11.55Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </Tooltip>
                                </>
                              )}
                            </React.Fragment>
                          )}
                      </>
                    )
                  ) : (
                    // tab Available Solutions
                    <React.Fragment>
                      <Tooltip title={t("ADD_TO_MY_SOLUTIONS")}>
                        {/* <IconButton color="primary" aria-label="Add to My Solutions" component="span" className={classes.cardIconButton}  style={{ color: props.tenantData.color }}>
                                                <AddCircleIcon className={classes.cardIcon} />
                                            </IconButton> */}
                        {props.product.offeringProvider == "MASTER_PROVIDER" ? (
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              navigate(
                                `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=true&isMaster=true`,
                              );
                            }}
                          >
                            <circle cx="10.5" cy="10.5" r="10.5" fill="white" />
                            <path
                              d="M17 10.8571H11.8571V16H10.1429V10.8571H5V9.14286H10.1429V4H11.8571V9.14286H17V10.8571Z"
                              fill={props.tenantData.color}
                            />
                          </svg>
                        ) : (
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              navigate(
                                `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=true&isMaster=false`,
                              );
                            }}
                          >
                            <circle cx="10.5" cy="10.5" r="10.5" fill="white" />
                            <path
                              d="M17 10.8571H11.8571V16H10.1429V10.8571H5V9.14286H10.1429V4H11.8571V9.14286H17V10.8571Z"
                              fill={props.tenantData.color}
                            />
                          </svg>
                        )}
                      </Tooltip>
                    </React.Fragment>
                  )
                ) : (
                  <React.Fragment>
                    {props.product.isBundle ? (
                      <Tooltip title={t("EDIT")}>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => {
                            navigate(
                              `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=false`,
                            );
                          }}
                        >
                          <circle
                            cx="10.5"
                            cy="10.5"
                            r="10.5"
                            fill={props.tenantData.color}
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM5 16V13.7087L11.758 6.9507L14.0493 9.24205L7.29135 16H5ZM15.8213 6.60853C16.0596 6.84683 16.0596 7.23177 15.8213 7.47007L14.7031 8.58825L12.4117 6.2969L13.5299 5.17873C13.7682 4.94042 14.1532 4.94042 14.3915 5.17873L15.8213 6.60853Z"
                            fill="white"
                          />
                        </svg>
                      </Tooltip>
                    ) : (
                      <Tooltip title={t("EDIT")}>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => {
                            props.editStandaloneProduct(
                              props.product.componentId,
                              props.product.componentType,
                            );
                          }}
                        >
                          <circle
                            cx="10.5"
                            cy="10.5"
                            r="10.5"
                            fill={props.tenantData.color}
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM5 16V13.7087L11.758 6.9507L14.0493 9.24205L7.29135 16H5ZM15.8213 6.60853C16.0596 6.84683 16.0596 7.23177 15.8213 7.47007L14.7031 8.58825L12.4117 6.2969L13.5299 5.17873C13.7682 4.94042 14.1532 4.94042 14.3915 5.17873L15.8213 6.60853Z"
                            fill="white"
                          />
                        </svg>
                      </Tooltip>
                    )}
                  </React.Fragment>
                )}
              </div>
              <div className={"cl"}></div>
            </div>
          </Paper>
        ) : (
          <Paper elevation={1} className={classes.paper}>
            <div>
              {/* <Link to={`${location.pathname}/${props.product.productOfferingId}`}> */}
              <Link
                to={
                  props.publicBrowsing
                    ? `/viewSolution/${props.product.productOfferingId}`
                    : `${location.pathname}/${props.product.productOfferingId}`
                }
                state={
                  !props.publicBrowsing &&
                    props.providerType === "SOLUTION_PROVIDER" &&
                    location.pathname === "/newOrder"
                    ? {
                      subscriptionData: props.subscriptionData || {}, // fixed typo
                      offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                      parentTenantId: props.tenantId,
                      availableCustomers: props.availableCustomers || [],
                    }
                    : !props.publicBrowsing
                      ? {
                        subscriptionData: props.subscriptionData || {},
                        offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                        availableCustomers: props.availableCustomers || [],
                      }
                      : undefined
                }
              >
                <img
                  border="0"
                  src={
                    props.product.largeImageUrl
                      ? constants.imageUrl + props.product.largeImageUrl
                      : placeholderImage
                  }
                  className={classes.cardImage}
                  alt=""
                  onError={DefaultImage}
                />
              </Link>
            </div>
            <div className={classes.cardBody}>
              <div className={classes.productTitle}>
                {props.solutionAction === "/product" ||
                  props.solutionAction === "/newOrder"
                  ? props.product.name
                  : props.product.productName}
              </div>
            </div>
            <div className={classes.cardDetail}>
              {(props.providerType === "SALES_CHNL_PROVIDER" ||
                props.publicBrowsing) && (
                  <div className={classes.priceGroup}>
                    <div align="left">
                      {props.product.isBundle && (
                        <span className={classes.catalogSmallText}>
                          {t("STARTING_FROM_TEXT")}
                        </span>
                      )}
                      <div
                        className={classes.price}
                        style={{ color: props.tenantData.color }}
                      >
                        {/* {currencyFormatter('', false)}{(Math.round(props.product.startingPrice * 100) / 100).toFixed(2)}{t('PER_MONTH')} */}
                        {currencyFormatter(props.product.price.priceAmount)}
                        {props.product.price.priceType === "RC"
                          ? t("PER_MONTH")
                          : ""}
                      </div>
                    </div>
                  </div>
                )}
              <div
                className={classes.placeOrderGroup}
                align={
                  props.providerType === "SALES_CHNL_PROVIDER" ||
                    props.publicBrowsing
                    ? "right"
                    : "center"
                }
                style={{
                  width:
                    props.providerType === "SALES_CHNL_PROVIDER" ||
                      props.publicBrowsing
                      ? "50%"
                      : "100%",
                }}
              >
                <Link
                  to={
                    props.publicBrowsing
                      ? `/viewSolution/${props.product.productOfferingId}`
                      : `${location.pathname}/${props.product.productOfferingId}`
                  }
                  state={
                    !props.publicBrowsing &&
                      props.providerType === "SOLUTION_PROVIDER" &&
                      (location.pathname === "/newOrder" || location.pathname === "/product")
                      ? {
                        subscriptionData: props.subscriptionData || {}, // fixed typo
                        offeringCustomer: props.offeringCustomer,
                        parentTenantId: props.tenantId,
                        availableCustomers: props.availableCustomers || [],
                      }
                      : !props.publicBrowsing
                        ? {
                          subscriptionData: props.subscriptionData || {},
                          offeringCustomer: props.offeringCustomer,
                          availableCustomers: props.availableCustomers || [],
                        }
                        : undefined
                  }
                >
                  {props.providerType === "SALES_CHNL_PROVIDER" ||
                    props.publicBrowsing ? (
                    <>
                      {/* <Button>Place Order</Button> */}
                      {props.menuPaths.includes("/newOrder/:id") &&
                        props.userPerms.includes("ORDERMGR_SALES_CREATE") && (
                          <Tooltip title={t("PLACE_ORDER")}>
                            <svg
                              viewBox="0 0 29 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.1872 16.1379H17.0247V11.5543H21.2808V8.4986H17.0247V3.91504H14.1872V8.4986H9.93105V11.5543H14.1872V16.1379ZM8.51233 29.8885C6.95173 29.8885 5.68907 31.2636 5.68907 32.9443C5.68907 34.6249 6.95173 36 8.51233 36C10.0729 36 11.3498 34.6249 11.3498 32.9443C11.3498 31.2636 10.0729 29.8885 8.51233 29.8885ZM22.6995 29.8885C21.1389 29.8885 19.8763 31.2636 19.8763 32.9443C19.8763 34.6249 21.1389 36 22.6995 36C24.2601 36 25.537 34.6249 25.537 32.9443C25.537 31.2636 24.2601 29.8885 22.6995 29.8885ZM8.75351 24.923L8.79607 24.7397L10.0729 22.2493H20.6424C21.7064 22.2493 22.6428 21.6229 23.1252 20.6756L28.6014 9.96534L26.1328 8.4986H26.1187L24.5581 11.5543L20.6424 19.1936H10.683L10.4985 18.7811L7.3206 11.5543L5.97282 8.4986L4.63922 5.44289H0V8.4986H2.83744L7.94484 20.095L6.02956 23.8382C5.80257 24.266 5.67488 24.7702 5.67488 25.305C5.67488 26.9856 6.95173 28.3607 8.51233 28.3607H25.537V25.305H9.10819C8.92375 25.305 8.75351 25.1369 8.75351 24.923Z"
                                fill="black"
                                fillOpacity="0.6"
                              />
                              <rect
                                x="9.93115"
                                y="3.91504"
                                width="11.3498"
                                height="12.2228"
                                fill="white"
                              />
                              <path
                                d="M24.2072 8.06904H20.4831V11.7932H19.2417V8.06904H15.5176V6.82766H19.2417V3.10352H20.4831V6.82766H24.2072V8.06904Z"
                                fill={props.tenantData.color}
                              />
                            </svg>
                          </Tooltip>
                        )}
                    </>
                  ) : // <Button>View</Button>
                    props.providerType === "SOLUTION_PROVIDER" &&
                      (location.pathname === "/newOrder" ||
                        location.pathname === "/product") &&
                      props.menuPaths.includes("/newOrder/:id") &&
                      props.userPerms.includes("ORDERMGR_SALES_CREATE") ? (
                      <Tooltip title={t("PLACE_ORDER")}>
                        <svg
                          viewBox="0 0 29 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.1872 16.1379H17.0247V11.5543H21.2808V8.4986H17.0247V3.91504H14.1872V8.4986H9.93105V11.5543H14.1872V16.1379ZM8.51233 29.8885C6.95173 29.8885 5.68907 31.2636 5.68907 32.9443C5.68907 34.6249 6.95173 36 8.51233 36C10.0729 36 11.3498 34.6249 11.3498 32.9443C11.3498 31.2636 10.0729 29.8885 8.51233 29.8885ZM22.6995 29.8885C21.1389 29.8885 19.8763 31.2636 19.8763 32.9443C19.8763 34.6249 21.1389 36 22.6995 36C24.2601 36 25.537 34.6249 25.537 32.9443C25.537 31.2636 24.2601 29.8885 22.6995 29.8885ZM8.75351 24.923L8.79607 24.7397L10.0729 22.2493H20.6424C21.7064 22.2493 22.6428 21.6229 23.1252 20.6756L28.6014 9.96534L26.1328 8.4986H26.1187L24.5581 11.5543L20.6424 19.1936H10.683L10.4985 18.7811L7.3206 11.5543L5.97282 8.4986L4.63922 5.44289H0V8.4986H2.83744L7.94484 20.095L6.02956 23.8382C5.80257 24.266 5.67488 24.7702 5.67488 25.305C5.67488 26.9856 6.95173 28.3607 8.51233 28.3607H25.537V25.305H9.10819C8.92375 25.305 8.75351 25.1369 8.75351 24.923Z"
                            fill="black"
                            fillOpacity="0.6"
                          />
                          <rect
                            x="9.93115"
                            y="3.91504"
                            width="11.3498"
                            height="12.2228"
                            fill="white"
                          />
                          <path
                            d="M24.2072 8.06904H20.4831V11.7932H19.2417V8.06904H15.5176V6.82766H19.2417V3.10352H20.4831V6.82766H24.2072V8.06904Z"
                            fill={props.tenantData.color}
                          />
                        </svg>
                      </Tooltip>
                    ) : (
                      <Tooltip title={t("VIEW")}>
                        <IconButton
                          color="primary"
                          aria-label="View"
                          component="span"
                          className={classes.cardIconButton}
                          style={{ color: props.tenantData.color }}
                        >
                          <IconButton className="buttonSecondary">
                            <ViewIconNew />
                          </IconButton>
                          {/* <VisibilityIcon className={classes.cardIcon} /> */}
                        </IconButton>
                      </Tooltip>
                    )}
                </Link>
              </div>
              <div className={"cl"}></div>
            </div>
          </Paper>
        )}
      </Badge>
    </Grid >
  );
};

const mapStateToProps = (state) => {
  return {
    userPerms: state.auth.userPerms,
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    publicBrowsing: state.auth.publicBrowsing,
    loggedInUserType: state.auth.userLoginType,
    menuPaths: state.auth.menuPaths,
  };
};

export default connect(mapStateToProps)(
  withTranslation("translations")(ProductCard),
);
